import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { EmptyState, Link } from '@atlassian/search-dialog';
import { injectIntl, FormattedMessage } from 'react-intl-next';
import { getTrigger, isNewTab } from '../analytics';
import { AdvancedSearchLinkSubjectId } from '../analytics/events';
import { messages } from '../../messages';
import Button from '@atlaskit/button';
import { ClearFiltersButtonWrapper } from './no-results.styled';
export var Image = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_product-search-dialog/async-chunk/no-result-image" */'./image');
});
export var NoResults = /*#__PURE__*/function (_React$Component) {
  function NoResults() {
    var _this;
    _classCallCheck(this, NoResults);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, NoResults, [].concat(args));
    _defineProperty(_this, "onAdvancedSearchClicked", function (e) {
      var _this$props = _this.props,
        advancedSearchSelected = _this$props.advancedSearchSelected,
        onClick = _this$props.onClick,
        advancedSearchUrl = _this$props.advancedSearchUrl;
      advancedSearchSelected({
        trigger: getTrigger(e),
        actionSubjectId: AdvancedSearchLinkSubjectId.NO_RESULTS,
        isLoading: false,
        newTab: isNewTab(e)
      });
      onClick && onClick(advancedSearchUrl, e);
    });
    _defineProperty(_this, "getContent", function () {
      var _this$props2 = _this.props,
        linkComponent = _this$props2.linkComponent,
        advancedSearchUrl = _this$props2.advancedSearchUrl,
        hasFilters = _this$props2.hasFilters,
        clearFilters = _this$props2.clearFilters,
        isMultiSite = _this$props2.isMultiSite;
      if (!hasFilters) {
        return (
          /*#__PURE__*/
          // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
          React.createElement("span", {
            role: "none",
            onClick: _this.onAdvancedSearchClicked
          }, isMultiSite || !advancedSearchUrl ? /*#__PURE__*/React.createElement(FormattedMessage, messages.common_empty_state_body_no_advanced_search) : /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.common_empty_state_body, {
            values: {
              a: function a(s) {
                return /*#__PURE__*/React.createElement(Link, {
                  linkComponent: linkComponent,
                  href: advancedSearchUrl
                }, s);
              }
            }
          })))
        );
      } else {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormattedMessage, _extends({
          tagName: "div"
        }, messages.filters_applied)), /*#__PURE__*/React.createElement(ClearFiltersButtonWrapper, null, /*#__PURE__*/React.createElement(Button, {
          appearance: "primary",
          onClick: clearFilters
        }, /*#__PURE__*/React.createElement(FormattedMessage, messages.clear_filters))));
      }
    });
    return _this;
  }
  _inherits(NoResults, _React$Component);
  return _createClass(NoResults, [{
    key: "render",
    value: function render() {
      var intl = this.props.intl;
      return /*#__PURE__*/React.createElement(EmptyState, {
        title: intl.formatMessage(messages.common_empty_state_heading),
        Image: Image,
        content: this.getContent()
      });
    }
  }]);
}(React.Component);
export default injectIntl(NoResults);